import {CTABanner, Button, Image, Section, Text} from '@primer/react-brand'
import {getAnalyticsEvent} from '@github-ui/swp-core/lib/utils/analytics'

import {Spacer} from './_shared'

const COPY = {
  heading: 'Millions of developers and businesses call GitHub home',
  description:
    'Whether you’re scaling your development process or just learning how to code, GitHub is where you belong. Join the world’s most widely adopted AI-powered developer platform to build the technologies that redefine what’s possible.',
  cta1: {
    label: 'Sign up',
    url: '/signup?source=form-home-signup',
  },
  cta2: {
    label: 'Try GitHub Copilot',
    subLabel: '30 days free',
    url: '/features/copilot',
  },
  visual: {
    url: '/images/modules/site/home24/cta.webp',
    alt: 'A subtle purple glow fades in as Mona the Octocat, Copilot, and Ducky dramatically fall into place next to one another while gazing optimistically into the distance.',
  },
}

export default function Cta() {
  return (
    <Section id="cta">
      <Spacer size="100px" />

      <Image
        src={COPY.visual.url}
        alt={COPY.visual.alt}
        width="960"
        style={{display: 'block', marginInline: 'auto'}}
        loading="lazy"
      />

      <Spacer size="48px" size1012="80px" />

      <CTABanner className="lp-Cta sh-CtaWithTrial" align="center" hasBackground={false} hasShadow={false}>
        <CTABanner.Heading as="h2">{COPY.heading}</CTABanner.Heading>

        <CTABanner.Description className="lp-Cta-description">{COPY.description}</CTABanner.Description>

        <CTABanner.ButtonGroup>
          <Button
            href={COPY.cta1.url}
            hasArrow={false}
            {...getAnalyticsEvent({action: 'sign_up', tag: 'button', context: 'CTAs', location: 'bottom_cta_section'})}
          >
            {COPY.cta1.label}
          </Button>
          <Button
            href={COPY.cta2.url}
            hasArrow={false}
            {...getAnalyticsEvent({
              action: 'try_copilot',
              tag: 'button',
              context: 'CTAs',
              location: 'bottom_cta_section',
            })}
          >
            {COPY.cta2.label}
            <Text className="sh-CtaWithTrial-label" size="100">
              {COPY.cta2.subLabel}
            </Text>
          </Button>
        </CTABanner.ButtonGroup>
      </CTABanner>
    </Section>
  )
}

try{ Cta.displayName ||= 'Cta' } catch {}